import * as React from 'react';
import * as ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import {
  CookiesViewModel,
  CounterJson,
  FormDetails,
  GoogleMapsJson,
  HiddenTextJson,
  ImageGalleryModel,
  LogotypeItem } from './empracoTypes';
import { LoadingSkeleton } from './generic/UtilityElements';
import HiddenText from './controls/HiddenText';
import { MainNavigation } from './controls/MainNavigation';
import { ShowBackgroundImages } from './generic/BackgroundImageLoading';
import { BaseCompositionPageListGallery } from './controls/BaseCompositionPageListGallery';
import { Counter } from './controls/Counter';
import { FormSelectorFns } from './controls/FormSelectorFns';

const GoogleMaps = React.lazy(() => import(/* webpackChunkName: "google-maps" */'./controls/GoogleMaps'));
const ImageGallery = React.lazy(() => import(/* webpackChunkName: "image-gallery" */'./controls/ImageGallery'));
const Cookies = React.lazy(() => import(/* webpackChunkName: "cookies" */'./controls/Cookies'));
const ReadTime = React.lazy(() => import(/* webpackChunkName: "read-time" */'./controls/ReadTime'));
const Logotypes = React.lazy(() => import(/* webpackChunkName: "logotypes" */'./controls/Logotypes'));

emporiModule('emporiLoaded', {
  controls: {
    InitGoogleMaps(element: string, model: GoogleMapsJson) {
      ReactDom.render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <GoogleMaps model={model} />
        </React.Suspense>, document.querySelector(element));
    },
    InitHiddenText(contentElement: string, buttonElement: string, model: HiddenTextJson) {
      HiddenText(contentElement, buttonElement, model);
    },
    InitMainNavigation(
      mainNav: HTMLDivElement,
      mobileTrigger: HTMLDivElement,
      secNav: HTMLDivElement,
      secTriggerer: HTMLDivElement) {
      MainNavigation(mainNav, mobileTrigger, secNav, secTriggerer);
    },
    InitCookies(element: string, model: CookiesViewModel) {
      ReactDom.render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <Cookies model={model} />
        </React.Suspense>, document.querySelector(element));
    },
    InitImageGallery(element: string, model: ImageGalleryModel) {
      ReactDom.render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <ImageGallery model={model} />
        </React.Suspense>, document.querySelector(element));
    },
    InitNewsArticle(element: string, calcEl: string) {
      ReactDom.render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <ReadTime textToCalc={calcEl} />
        </React.Suspense>, document.querySelector(element));
    },
    InitBaseCompositionPageListGallery(element: string) {
      BaseCompositionPageListGallery(element);
    },
    InitCounter(counter: CounterJson) {
      Counter(counter);
    },
    InitLogotypes(element: string, items: LogotypeItem[] | null) {
      ReactDom.render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <Logotypes items={items} />
        </React.Suspense>, document.querySelector(element));
    },
    InitFormSelectorFns(formDetails: FormDetails) {
      FormSelectorFns(formDetails);
    }
  }
});

ShowBackgroundImages();